import { Skeleton } from "@stacklet/ui";

import { TableSkeleton } from "./TableSkeleton";

interface Props {
  searchBar?: boolean;
}

export function DetailsSkeleton({ searchBar }: Props) {
  return (
    <>
      <Skeleton
        className="mt-[104px]"
        height="32px"
        variant="rectangular"
        width="100%"
      />
      <Skeleton
        className="mt-[40px]"
        height="225px"
        variant="rectangular"
        width="100%"
      />
      {searchBar ? (
        <Skeleton
          className="mt-[56px]"
          height="32px"
          variant="rectangular"
          width="100%"
        />
      ) : null}
      <TableSkeleton topMargin={5} />
    </>
  );
}
